import {
  DELAY_DEFAULT_FILTERS,
  DELAY_DEFAULT_FORM,
} from 'domain/delay-tracker';

const initialState = {
  items: [],
  total: 0,
  filters: DELAY_DEFAULT_FILTERS,
  form: DELAY_DEFAULT_FORM,
  logPdf: null,
  error: null,
};

export default function delayTrackerDataReducer(
  state = initialState,
  action = {}
) {
  switch (action.type) {
    case 'DELAY_TRACKER_SET_ITEMS':
      return { ...state, items: action.payload };
    case 'DELAY_TRACKER_SET_TOTAL':
      return { ...state, total: action.payload };
    case 'DELAY_TRACKER_SET_FILTERS':
      return { ...state, filters: action.payload };
    case 'DELAY_TRACKER_SET_FORM':
      return { ...state, form: { ...state.form, ...action.payload } };
    case 'DELAY_TRACKER_RESET_FORM':
      return { ...state, form: DELAY_DEFAULT_FORM };
    case 'DELAY_TRACKER_ADD_ITEM':
      return { ...state, items: [action.payload, ...state.items] };
    case 'DELAY_TRACKER_UPDATE_ITEM':
      return {
        ...state,
        items: state.items.map((it) =>
          it.id === action.payload.id ? action.payload : it
        ),
      };
    case 'DELAY_TRACKER_DELETE_ITEM':
      return {
        ...state,
        items: state.items.filter((it) => it.id !== action.payload),
      };
    case 'DELAY_TRACKER_SET_LOG_PDF':
      return { ...state, logPdf: action.payload };
    case 'DELAY_TRACKER_SET_ERROR':
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
